var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"600"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_vm._t("activator",null,{"on":on})]}}],null,true)},[_c('v-card',[_c('CardTitle',{attrs:{"title":"Emails failed to send","dense":""}}),_c('v-card-text',[_c('v-simple-table',[_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v("No Data")])])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }